import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from '@hooks/useTranslation';
import type { CalculationType } from '@/react/api/calculationType';

const ORDER: CalculationType[] = ['flat', 'pax', 'percentage'];

const FALLBACK_LABELS: Record<CalculationType, string> = {
  flat: 'Flat',
  pax: 'Per guest',
  percentage: 'Percentage (food total only)',
};

interface MultiplierDropdownProps {
  value: CalculationType | '';
  onChange: (value: CalculationType) => void;
  triggerClassName?: string;
}

export function MultiplierDropdown({ value, onChange, triggerClassName }: MultiplierDropdownProps) {
  const { t } = useTranslation();

  const optionLabel = (type: CalculationType) =>
    t(`common.multipliers.${type}`, FALLBACK_LABELS[type]);

  return (
    <Select
      value={value || undefined}
      onValueChange={(next) => onChange(next as CalculationType)}
    >
      <SelectTrigger className={triggerClassName}>
        <SelectValue
          placeholder={t('common.multiplier_dropdown.placeholder', 'Select multiplier')}
        />
      </SelectTrigger>
      <SelectContent>
        {ORDER.map((type) => (
          <SelectItem key={type} value={type}>
            {optionLabel(type)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
